import React, { useState } from "react";
import { toast } from "react-toastify";
import * as yup from "yup";
import axios from "axios";
import { useFormik } from "formik";
import { base_url } from "../../Utils/baseUrl";
import { useLocation, useNavigate } from "react-router-dom";
import commonFunction from "../../Utils/commonFunction";
import "./Resetpassword.css";

function Resetpassword() {
    const location = useLocation();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorResponse, setErrorResponse] = useState("");

    const navigate = useNavigate();
    const validationSchema = yup.object({
        otp: yup.string().required("Engangsadgangskoden er nødvendig"),
        email: yup.string().email("Ugyldig Email").required("Email is required"),
        password: yup
            .string()
            .required("Adgangskode er nødvendig")
            .min(8, "Adgangskode for kort - Skal være mindst 8 karakter lang")
            .matches(/[a-zA-Z]/, "Adgangskode kan kun indeholde latinske bogstaver"),
    });

    const formik = useFormik({
        initialValues: {
            otp: "",
            email: location?.state?.email || '',
            password: "",
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            axios
                .post(`${base_url}/auth/reset-password`, values)
                .then((res) => {
                    setSuccessMessage("Du kan nu logge ind med din nye adgangskode.");
                })
                .catch((err) => {
                    setErrorResponse(err?.response?.data?.message || "Something went wrong");
                    formik.resetForm({
                        values: {
                            otp: "",
                            email: location?.state?.email || "",
                            password: "",
                        },
                    });
                });
        },
    });

    const handleResendOtp = async () => {
        try {
            const data = {
                email: location?.state?.email || "",
            };
            const response = await commonFunction.sendOtp(data);
            if (response.status === 200) {
                toast.success(response.data.message);
            }
        } catch (error) {
            toast.error("Something went wrong");
        }
    };

    const handleChangeEmail = () => {
        navigate("/forgot-password");
    };

    const handleSuccessClose = () => {
        setSuccessMessage("");
        navigate("/login");
    };

    const handleSuccessDismiss = () => {
        setSuccessMessage("");
        navigate("/login");
    };

    const handleCloseError = () => {
        setErrorResponse('')
    }

    return (
        <main>
            {successMessage && (
                <div
                    className="password-success-overlay"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="password-success-title"
                    onClick={handleSuccessDismiss}
                >
                    <div
                        className="password-success-modal"
                        onClick={(event) => event.stopPropagation()}
                    >
                        <div className="password-success-icon" aria-hidden="true">
                            &#10003;
                        </div>
                        <h2 id="password-success-title">Din adgangskode er blevet opdateret.</h2>
                        <p>{successMessage}</p>
                        <button
                            type="button"
                            className="password-success-button"
                            onClick={handleSuccessClose}
                            autoFocus
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}

            {errorResponse && (
                <div
                    className="password-success-overlay"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="password-success-title"
                    onClick={handleCloseError}
                >
                    <div
                        className="password-success-modal"
                        onClick={(event) => event.stopPropagation()}
                    >
                        <div className="password-success-icon" aria-hidden="true">
                            &#10003;
                        </div>
                        <h2 id="password-success-title">Din adgangskode er blevet opdateret.</h2>
                        <div className="error-message" style={{ padding: "10px 0px 20px 0px", justifyContent: 'center' }}>
                            <span className="error-icon">!</span>
                            <span>{errorResponse}</span>
                        </div>
                        <button
                            type="button"
                            className="password-success-button"
                            onClick={handleCloseError}
                            autoFocus
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
            <section className="login-sec signup-sec wow pulse">
                <div className="container">
                    <div className="login-inner">
                        <div className="row">

                            {/* LEFT SIDE */}
                            <div className="col-md-6">
                                <form
                                    className="form_elements reset-password-form"
                                    onSubmit={formik.handleSubmit}
                                >

                                    {/* Heading */}
                                    <div className="reset-password-title">
                                        <h2>Nulstil Adgangskode</h2>
                                    </div>

                                    {/* EMAIL */}
                                    <div className="reset-form-group">
                                        <div className="reset-label">
                                            <label htmlFor="email">
                                                Email ID
                                            </label>
                                            <abbr>*</abbr>
                                        </div>

                                        <div className="reset-input-wrapper">
                                            <input
                                                type="email"
                                                className="form-control reset-input"
                                                id="email"
                                                name="email"
                                                placeholder="Email"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.email || ''}
                                                disabled
                                            />
                                        </div>

                                        {formik.touched.email &&
                                            formik.errors.email ? (
                                            <div className="error-message">
                                                <span className="error-icon">!</span>
                                                <span>{formik.errors.email}</span>
                                            </div>
                                        ) : null}

                                        <button
                                            type="button"
                                            className="change-email-link"
                                            onClick={handleChangeEmail}
                                        >
                                            Ændr e-mailadresse
                                        </button>
                                    </div>

                                    {/* INFORMATION BOX */}
                                    <div className="reset-info-box">
                                        <div className="reset-info-icon">
                                            i
                                        </div>

                                        <div className="reset-info-text">
                                            Hvis der findes en konto med denne
                                            e-mailadresse, har vi sendt en
                                            engangsadgangskode.
                                        </div>
                                    </div>

                                    {/* OTP */}
                                    <div className="reset-form-group otp-group">
                                        <div className="reset-label">
                                            <label htmlFor="otp">
                                                Engangsadgangskode
                                            </label>
                                            <abbr>*</abbr>
                                        </div>

                                        <input
                                            type="text"
                                            className="form-control reset-input"
                                            id="otp"
                                            name="otp"
                                            placeholder="Indtast Engangsadgangskoden som blev sendt til din email"
                                            onChange={(e) => {
                                                const value =
                                                    e.target.value;

                                                if (
                                                    /^[0-9]*$/.test(value)
                                                ) {
                                                    formik.handleChange(e);
                                                }
                                            }}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.otp}
                                            pattern="[0-9]*"
                                        />

                                        {formik.touched.otp &&
                                            formik.errors.otp ? (
                                            <div className="error-message">
                                                <span className="error-icon">!</span>
                                                <span>{formik.errors.otp}</span>
                                            </div>
                                        ) : null}

                                        <p className="otp-help-text">
                                            Har du ikke modtaget koden? Tjek
                                            spam eller uønsket post, eller send
                                            koden igen.
                                        </p>
                                    </div>

                                    {/* PASSWORD */}
                                    <div className="reset-form-group password-group">
                                        <div className="reset-label">
                                            <label htmlFor="password">
                                                Adgangskode
                                            </label>
                                            <abbr>*</abbr>
                                        </div>

                                        <div className="reset-input-wrapper">
                                            <input
                                                type="password"
                                                className="form-control reset-input"
                                                id="password"
                                                name="password"
                                                placeholder="Indtast Ny Adgangskode"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.password}
                                            />
                                        </div>

                                        {formik.touched.password &&
                                            formik.errors.password ? (
                                            <div className="error-message">
                                                <span className="error-icon">!</span>
                                                <span>{formik.errors.password}</span>
                                            </div>
                                        ) : null}
                                    </div>

                                    {/* RESEND */}
                                    <button
                                        type="button"
                                        className="resend-otp-link"
                                        onClick={handleResendOtp}
                                    >
                                        Send Engangsadgangskoden Igen
                                    </button>

                                    {/* BUTTON */}
                                    <div className="btn_submit reset-submit">
                                        <button
                                            type="submit"
                                            className="btn btn-1 w-100"
                                            disabled={formik.isSubmitting}
                                        >
                                            Bekræft
                                        </button>
                                    </div>
                                </form>
                            </div>

                            {/* RIGHT SIDE - UNCHANGED */}
                            <div className="col-md-6">
                                <div className="reset-img">
                                    {/* Your existing content/image */}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Resetpassword;
